<section class="p-4 space-y-5" aria-labelledby="financials-workspace-title">
  <header>
    <h1 id="financials-workspace-title" class="text-2xl font-semibold">Financials</h1>
    <p class="text-sm text-gray-600">Managed accountancy workspace</p>
  </header>

  <nav aria-label="Financials navigation" class="flex flex-wrap gap-2 border-b border-gray-200 pb-3">
    @for (section of sections; track section.path) {
      <a
        class="rounded px-3 py-2 text-sm hover:bg-gray-100"
        [routerLink]="section.path"
        routerLinkActive="bg-gray-100 font-semibold"
        [routerLinkActiveOptions]="{ exact: true }"
      >{{ section.label }}</a>
    }
  </nav>

  <router-outlet />
</section>
